// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import React from 'react';

export default class StatusDndAvatarIcon extends React.PureComponent {
    render() {
        return (
            <span {...this.props}>
                <svg
                    id='Layer_1'
                    x='0px'
                    y='0px'
                    width='13px'
                    height='13px'
                    viewBox='-299 391 12 12'
                    style={style}
                >
                    <g>
                        <g>
                            <ellipse
                                className='offline--icon'
                                cx='-294.5'
                                cy='394'
                                rx='2.5'
                                ry='2.5'
                            />
                            <path
                                className='offline--icon'
                                d='M-294.3,399.7c0-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.2,0-0.4,0c-2.5,0-2.5-2-2.5-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5 c0,0.1-0.1,0.5,0,0.6c0.2,1.3,2.2,2.3,4.4,2.4h0.1h0.1c0.3,0,0.7,0,1-0.1C-293.9,401.6-294.3,400.7-294.3,399.7z'
                            />
                        </g>
                    </g>
                    <g>
                        <path
                            className='offline--icon'
                            d='M-288.9,399.4l1.8-1.8c0.1-0.1,0.1-0.3,0-0.3l-0.7-0.7c-0.1-0.1-0.3-0.1-0.3,0l-1.8,1.8l-1.8-1.8c-0.1-0.1-0.3-0.1-0.3,0 l-0.7,0.7c-0.1,0.1-0.1,0.3,0,0.3l1.8,1.8l-1.8,1.8c-0.1,0.1-0.1,0.3,0,0.3l0.7,0.7c0.1,0.1,0.3,0.1,0.3,0l1.8-1.8l1.8,1.8 c0.1,0.1,0.3,0.1,0.3,0l0.7-0.7c0.1-0.1,0.1-0.3,0-0.3L-288.9,399.4z'
                        />
                    </g>
                </svg>
            </span>
        );
    }
}

const style = {
    enableBackground: 'new -299 391 12 12'
};



// WEBPACK FOOTER //
// ./components/svg/status_offline_avatar_icon.jsx